enum EventLocationOption {
    OnCampus = 'event_location_option--on_campus',
    OffCampus = 'event_location_option--off_campus',
    Virtual = 'event_location_option--virtual',
}

export default EventLocationOption;
